import { useEffect, useMemo } from 'react';
import {
  Button,
  Card,
  CardContent,
  Checkbox,
  Dialog,
  DialogActions,
  DialogContent,
  DialogTitle,
  FormControl,
  IconButton,
  InputLabel,
  MenuItem,
  OutlinedInput,
  Select, TextField
} from '@mui/material';
import { useTheme } from '@mui/material/styles';
import * as Yup from 'yup';
import { Controller, useForm } from 'react-hook-form';
import { yupResolver } from '@hookform/resolvers/yup';
import LoadingButton from '@mui/lab/LoadingButton';
import Box from '@mui/material/Box';
import { useSnackbar } from 'src/components/snackbar';
import FormProvider, { RHFAutocomplete } from 'src/components/hook-form';
import { postRequest } from 'src/services';
import { endpoints } from 'src/utils/axios';
import { handleErrorMessages } from '../../risk-register/feching';
import Iconify from 'src/components/iconify';
import { DatePicker } from '@mui/x-date-pickers';
const CreateIssuePaymentModal = ({ open, onClose, reload, currentItem,users ,employees ,bankInformation }) => {
  const theme = useTheme();
  const { enqueueSnackbar } = useSnackbar();
  const NewUserSchema = Yup.object().shape({
  });
  const defaultValues = useMemo(
    () => ({
 
    }),
    []
  );
  const methods = useForm({
    resolver: yupResolver(NewUserSchema),
    defaultValues,
  });

  const {
    reset,
    control,
    handleSubmit,
    clearErrors,
    setValue,
    formState: { isSubmitting },
  } = methods;

  useEffect(() => {
    reset(defaultValues);
  }, [ currentItem, reset, defaultValues ]);

  const handleCloseForm = () => {
    reset(defaultValues);
    onClose();
  };

  const onSubmit = handleSubmit(async (data) => {
    console.log('Form data submitted:', data);
    const formData = new FormData();
    users?.forEach(id => formData.append('user_ids[]', id?.id))
    try {
      const response = await postRequest(`${endpoints.accounting.payroll.generate_payroll.assign_share_users}/${currentItem.id}/assign`,
        formData,
        true
      );
      if (response) {
        reset();
        handleCloseForm()
        enqueueSnackbar({
          variant: 'success',
          message: response?.metadata?.message,
        });
      } else {
        handleErrorMessages(response?.metadta?.message ); 
      }
    } catch (err) {
      console.error('Error:', err);
      handleErrorMessages(err.message || 'Submission failed.');
    } finally {
    }
  });
  return (
    <Dialog
      open={ open }
      onClose={ (event, reason) => {
        if (reason !== 'backdropClick') {
          handleCloseForm();
        }
      } }
      fullWidth
      maxWidth="sm"
      sx={ {
        borderRadius: 'none',
        padding: '60px',
        fontSize: '13px',
        fontFamily: 'arial',
      } }
      transitionDuration={ {
        enter: theme.transitions.duration.shortest,
        exit: theme.transitions.duration.shortest - 80,
      } }
    >
      <FormProvider methods={ methods } onSubmit={ onSubmit }>
        <DialogTitle
          sx={ {
            display: 'flex',
            justifyContent: 'space-between',
            alignItems: 'center',
            boxSizing: 'content-box',
          } }
        >
          <span
            className="cardColor"
            style={ { padding: '7px', marginLeft: '-25px', color: 'white', fontWeight: '700' } }
          >
            &nbsp;&nbsp; Share Modal &nbsp;&nbsp;&nbsp;&nbsp;
          </span>
          <IconButton onClick={ () => { onClose() } }>
            <Iconify icon="mdi:close" />
          </IconButton>
        </DialogTitle>
        <DialogContent
          sx={ {
            borderRadius: '1px',
          } }
        >
             <FormProvider methods={ methods } onSubmit={ onSubmit }>
                          {/* Form Section */ }
                          <Card sx={ { mb: 3, mx: 2 } }>
                              <CardContent
                                  sx={ {
                                      bgcolor: "#919EAB14",
                                      boxShadow:
                                          "rgba(0, 0, 0, 0.05) 0px 6px 24px 0px, rgba(0, 0, 0, 0.08) 0px 0px 0px 1px",
                                  } }
                              >
                                  <Box
                                      mt={ 2 }
                                      mb={ 2 }
                                      gap={ 3 }
                                      display="grid"
                                      gridTemplateColumns={ { xs: 'repeat(3, 1fr)', lg: 'repeat(3, 1fr)' } }
                                  >
                                      <Controller
                                          name="employee_ids"
                                          control={ control }
                                          defaultValue={ [] }
                                          render={ ({ field: { onChange, value }, fieldState: { error } }) => {
                                              const isAllSelected = value.length === employees.length;
                                              const isIndeterminate = value.length > 0 && value.length < employees.length;
          
                                              const handleSelectAllClick = () => {
                                                  if (isAllSelected) {
                                                      onChange([]);
                                                  } else {
                                                      onChange(employees.map((emp) => emp.id));
                                                  }
                                              };
          
                                              return (
                                                  <FormControl
                                                      error={ !!error }
                                                      sx={ { flexShrink: 1, width: { xs: 1, md: 1 } } }
                                                  >
                                                      <InputLabel>Employees</InputLabel>
                                                      <Select
                                                          multiple
                                                          value={ value }
                                                          // Enhanced onChange for Select All logic
                                                          onChange={ (event) => {
                                                              const { value: selected } = event.target;
          
                                                              // If 'all' is selected, toggle all, else proceed as normal
                                                              if (selected[ selected.length - 1 ] === 'all') {
                                                                  if (isAllSelected) {
                                                                      onChange([]);
                                                                  } else {
                                                                      onChange(employees.map((emp) => emp.id));
                                                                  }
                                                              } else {
                                                                  onChange(selected);
                                                              }
                                                          } }
                                                          input={ <OutlinedInput label="Employees" /> }
                                                          renderValue={ (selected) =>
                                                              employees
                                                                  .filter((emp) => selected.includes(emp.id))
                                                                  .map((emp) => emp.first_name + ' ' + emp.last_name)
                                                                  .join(', ')
                                                          }
                                                          MenuProps={ { PaperProps: { sx: { maxHeight: 240 } } } }
                                                      >
                                                          {/* Static All Option */ }
                                                          <MenuItem value="all">
                                                              <Checkbox checked={ isAllSelected } indeterminate={ isIndeterminate } />
                                                              Select All
                                                          </MenuItem>
          
                                                          {/* Employee Options */ }
                                                          { employees?.map((emp) => (
                                                              <MenuItem key={ emp.id } value={ emp.id }>
                                                                  <Checkbox checked={ value.includes(emp.id) } />
                                                                  { emp.first_name } { emp.last_name }
                                                              </MenuItem>
                                                          )) }
                                                      </Select>
          
                                                  </FormControl>
                                              );
                                          } }
                                      />
                                      <Controller
                                          name="date"
                                          control={ control }
                                          render={ ({ field, fieldState: { error } }) => (
                                              <DatePicker
                                                  label="Date*"
                                                  { ...field }
                                                  inputFormat="yyyy-MM-dd"
                                                  renderInput={ (params) => (
                                                      <TextField
                                                          { ...params }
                                                          fullWidth
                                                          error={ !!error }
                                                          helperText={ error?.message }
                                                      />
                                                  ) }
                                              />
                                          ) }
                                      />
          
                                      <RHFAutocomplete
                                          name="payment_method"
                                          label="Payment Method"
                                          options={ [ 'Cash', 'Cheque', 'Credit Card', 'Debit Card', 'ACH' ] }
                                          getOptionLabel={ (option) => option?.name || option }
                                          isOptionEqualToValue={ (option, value) => option === value }
                                          renderOption={ (props, option) => (
                                              <li { ...props } key={ option?.id || option }>
                                                  { option?.name || option }
                                              </li>
                                          ) }
                                      />
          
                                           <Box sx={{ display: 'flex', alignItems: 'flex-start', width: '100%' }}>
                                                <RHFAutocomplete
                                                  sx={{ width: '100%' }}
                                                  name="bank_information_id"
                                                  label="Name of Bank"
                                                  options={bankInformation}
                                                  onChange={(_, value) => {
                                                    setValue('bank_information_id', value);
                                                    clearErrors('bank_information_id');
                                                  }}
                                                  getOptionLabel={(option) => option?.bank_name || ''}
                                                  isOptionEqualToValue={(option, value) => option.id === value.id}
                                                  renderOption={(props, option) => (
                                                    <li {...props} key={option.id}>
                                                      {option.bank_name}
                                                    </li>
                                                  )}
                                                />
                                                {/* <IconButton
                                                  onClick={handleOpen}
                                                  className="cardColor"
                                                  sx={{
                                                    margin: '5px 10px',
                                  
                                                    color: '#FFF',
                                                    fontSize: 25,
                                                    padding: '7px',
                                                    borderRadius: '50%',
                                                    '&:hover': {
                                                      backgroundColor: '#7AB13A',
                                                    },
                                                    boxShadow: '0 3px 5px rgba(0, 0, 0, 0.2)',
                                                  }}
                                                >
                                                  <Iconify icon="mingcute:add-line" />
                                                </IconButton> */}
                                              </Box>
                                  </Box>
                              </CardContent>
                          </Card>
                      
                      </FormProvider>
        
        </DialogContent>
        <DialogActions>
          <Button variant="outlined" color="inherit" onClick={ () => {handleCloseForm() } }>
            Cancel
          </Button>
          <LoadingButton
            type="submit"
            variant="contained"
            className="dark-button"
            loading={ isSubmitting }
          >
            Submit
          </LoadingButton>
        </DialogActions>
      </FormProvider>
    </Dialog>
  );
};
export default CreateIssuePaymentModal;